import { retryIntervalPhrase } from '../../configuration/interval-unit.util';

/** Snackbar after ALERT — snapshot interval and follow-ups. No 2-hour window. */
export function alertStartedMessage(config: {
  retryIntervalMinutes: number;
  retryAttempts: number;
}): string {
  const interval = retryIntervalPhrase(config.retryIntervalMinutes);
  const followUps = Math.max(1, config.retryAttempts);
  const times = followUps === 1 ? '1 more time' : `${followUps} more times`;
  return `We've sent a text and placed a call. We'll alert again every ${interval}, up to ${times}, until someone responds.`;
}
